// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yxkk","label":"styles_label__3lIzY"};